import React, { createContext, useContext } from 'react';
import { AppShellProps } from './types';

const AppShellContext = createContext<AppShellProps>({} as AppShellProps);

export const AppShellProvider: React.FC<AppShellProps> = ({ children, ...props }): React.ReactElement => (
    <AppShellContext.Provider value={props}>{children}</AppShellContext.Provider>
);

const useAppShell = (): AppShellProps => useContext(AppShellContext);

export default useAppShell;
